<template>
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--lg">

                    <!-- ========== HEADER ========== -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-money-euro-box-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">Billetage de la caisse</h4>
                                <p class="cf-modal-head__sub">Comptez les espèces avant la fermeture</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <!-- ========== BODY ========== -->
                    <div class="cf-dialog-body">
                        <div v-if="messagesucces!==''" class="cf-note cf-note--info" style="margin-bottom:0.75rem;">
                            <i class="ri-check-circle-line"></i><span v-html="messagesucces"></span>
                        </div>
                        <div v-if="messageerror!==''" class="cf-note cf-note--danger" style="margin-bottom:0.75rem;">
                            <i class="ri-error-warning-line"></i><span v-html="messageerror"></span>
                        </div>

                        <div class="table-scroll-wrap doc-scroll">
                            <table class="doc-table">
                                <thead>
                                    <tr>
                                        <th class="th" style="text-align:center">Montant</th>
                                        <th class="th" style="text-align:center">Nombre</th>
                                        <th class="th" style="text-align:center">Montant total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="table-row" v-for="(ligne,index) in billetage.ligne" :key="index">
                                        <td class="td cf-strong" data-label="Montant : " style="width:30%; text-align:center">{{ligne.intitule}}</td>
                                        <td class="td" data-label="Nombre : " style="width:30%; text-align:center">
                                            <input class="cf-inp cf-inp--num" @change="calculmontant" type="number" v-model="ligne.nombre">
                                        </td>
                                        <td class="td" data-label="Montant total : " style="width:40%; text-align:center">{{formatNumber(ligne.montanttotale)}}</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr class="cf-total-row" v-if="accesviewrapporteditioncaisse">
                                        <td colspan="2" class="td"><p class="text-center mt-0 mb-0">Montant attendu</p></td>
                                        <td class="td cf-total-amount"><p style="text-align:center">{{formatNumber(billetage.montantattendu)}}</p></td>
                                    </tr>
                                    <tr class="cf-total-row">
                                        <td colspan="2" class="td"><p class="text-center mt-0 mb-0">Montant physique</p></td>
                                        <td class="td cf-total-amount"><p style="text-align:center">{{formatNumber(billetage.montantphisque)}}</p></td>
                                    </tr>
                                    <tr class="cf-total-row" v-if="accesviewrapporteditioncaisse">
                                        <td colspan="2" class="td"><p class="text-center mt-0 mb-0">Écart</p></td>
                                        <td class="td cf-total-amount"><p style="text-align:center">{{formatNumber(billetage.ecart)}}</p></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    <!-- ========== FOOTER ========== -->
                    <div class="cf-dialog-foot">
                        <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Non</button>
                        <button @click="btnvalider" type="button" class="ti-btn ti-btn-primary-full">
                            <i class="ri-check-line align-middle"></i> Oui
                        </button>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>
</template>

<script>

    //import allfunction from "@/allfunction";
    import {currencyFormatDE, randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "formsupp",
        watch: {


        },

        computed:{




        },
        components: {


        },

        data() {
            return {
                isdisplay:false,
                accesviewrapporteditioncaisse:true,
                datavalue:"",
                titlemodal:"",
                Items:{},
                typedoc:"",
                messageerror:"",
                messagesucces:"",
                billetage:{
                    ligne:[

                        {
                            intitule:'10.000 FCFA',
                            intituleenchiffre:10000,
                            nombre:0,
                            montanttotale:0
                        },
                        {
                            intitule:'5.000 FCFA',
                            intituleenchiffre:5000,
                            nombre:0,
                            montanttotale:0
                        },
                        {
                            intitule:'2.000 FCFA',
                            intituleenchiffre:2000,
                            nombre:0,
                            montanttotale:0
                        },
                        {
                            intitule:'1.000 FCFA',
                            intituleenchiffre:1000,
                            nombre:0,
                            montanttotale:0
                        },
                        {
                            intitule:'500 FCFA',
                            intituleenchiffre:500,
                            nombre:0,
                            montanttotale:0
                        },
                        {
                            intitule:'250 FCFA',
                            intituleenchiffre:250,
                            nombre:0,
                            montanttotale:0
                        },
                        {
                            intitule:'200 FCFA',
                            intituleenchiffre:200,
                            nombre:0,
                            montanttotale:0
                        },
                        {
                            intitule:'100 FCFA',
                            intituleenchiffre:100,
                            nombre:0,
                            montanttotale:0
                        },
                        {
                            intitule:'50 FCFA',
                            intituleenchiffre:50,
                            nombre:0,
                            montanttotale:0
                        },
                        {
                            intitule:'25 FCFA',
                            intituleenchiffre:25,
                            nombre:0,
                            montanttotale:0
                        },
                        {
                            intitule:'20 FCFA',
                            intituleenchiffre:20,
                            nombre:0,
                            montanttotale:0
                        },
                        {
                            intitule:'10 FCFA',
                            intituleenchiffre:10,
                            nombre:0,
                            montanttotale:0
                        },
                        {
                            intitule:'5 FCFA',
                            intituleenchiffre:5,
                            nombre:0,
                            montanttotale:0
                        },
                        {
                            intitule:'1 FCFA',
                            intituleenchiffre:1,
                            nombre:0,
                            montanttotale:0
                        },

                    ],
                    montantattendu:0,
                    montantphisque:0,
                    ecart:0,

                }
            };
        },
        methods: {



            formatNumber(num) {

                return  currencyFormatDE(num)
            },



            calculmontant(){
                let    montantattendu=0;
                let     montantphisque=0;
                let     ecart=0;


                this.billetage.ligne.forEach(function (ligne) {
                    ligne.montanttotale=ligne.nombre*ligne.intituleenchiffre
                    montantphisque=ligne.montanttotale+montantphisque
                })

                this.billetage.montantphisque=montantphisque;
                this.billetage.ecart=montantphisque-this.billetage.montantattendu;

            },


            close(){

                this.isdisplay=false;

                this.$emit('closed');


            },


            show(montantattendu,accesviewrapporteditioncaisse){
                this.messagesucces="";
                this.messageerror="";
                this.billetage.montantattendu=montantattendu
                this.accesviewrapporteditioncaisse=accesviewrapporteditioncaisse

                this.isdisplay=true;

            },


            async  btnvalider(){

                this.$store.dispatch('lancerchargement',true)

                if (this.billetage.montantattendu>0){


                    if (this.billetage.montantphisque<=0){

                        toastr['error']( "Le billetage de la caisse n'est pass valide. Veuillez reprendre.",
                            "<b>Caisse</b>")
                        this.$store.dispatch('lancerchargement',false)
                        return
                    }




                }

                var caisse={
                    dateouverture:this.$store.state.dateouverturecaisse,
                    cc:this.$store.state.caisseencour,
                    cinfo:this.$store.state.caisseinfo,
                    billetage:this.billetage
                }

                const t = this;
                let url=process.env.VUE_APP_API_URL+'/egl74587kjkjrfdkcaisse771714dfe/caisse/fkdfkdo785544hffgzojdj/'+this.$store.state.appsociete+'/close/'+randomString();
                let response =   axios  .post(url,caisse,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        // t.$store.dispatch('beartoken',res.data.beartoken)
                        t.$store.dispatch('lancerchargement',false)
                        if(res.data.success){

                            t.messagesucces="";
                            t.messageerror="";

                            t.messagesucces=res.data.message;

                            toastr['success']( t.messagesucces,"<b></b>");


                           // t.$emit('closed',res.data.m);

                            t.$store.commit('listeallcaisses',{value:res.data.c})


                            t.$router.push({ name: 'tcaisse'});


                            t.isdisplay=false;


                        }
                        else{

                            let errormessage="";

                            t.messageerror="";
                            t.messagesucces="";
                            if (res.data.datamessage.length>0){

                                for (let message of res.data.datamessage){

                                    if (errormessage===""){

                                        errormessage=message;

                                    }else{

                                        errormessage+=" , "+message;

                                    }


                                }


                                t.messageerror=errormessage;

                            }
                            else{
                                t.messageerror=res.data.message
                            }


                            toastr['error'](t.messageerror,"<b></b>");

                            t.isdisplay=false;

                        }


                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                            "<b></b>")
                    )
                    .finally(() => this.$store.dispatch('lancerchargement',false))




            },







        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--lg { max-width:640px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

/* Table */
.table-scroll-wrap { overflow:auto; }
.doc-scroll { max-height:56vh; }
.doc-table { width:100%; text-align:left; font-size:13px; border-collapse:collapse; }
.th { position:sticky; top:0; z-index:2; padding:0.7rem 1rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; }
.table-row { border-bottom:1px solid var(--cf-surface-alt); }
.table-row:hover { background:var(--cf-surface); }
.td { padding:0.6rem 1rem; font-size:0.82rem; color:var(--cf-ink); vertical-align:middle; }
.cf-strong { font-weight:600; color:var(--cf-ink-strong); }
.cf-inp--num { width:110px; text-align:center; }
.cf-inp { padding:7px 10px; border:1px solid rgb(var(--input-border,203 213 225)); border-radius:var(--cf-radius-sm); font-size:0.82rem; color:var(--cf-ink); outline:none; transition:border-color 0.2s; }
.cf-inp:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.cf-total-row { background:var(--cf-surface-alt); font-weight:600; }
.cf-total-row .td { color:var(--cf-ink-strong); }
.cf-total-amount { font-variant-numeric:tabular-nums; font-weight:700; color:rgb(var(--primary)); }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

.doc-scroll::-webkit-scrollbar { width:6px; height:6px; }
.doc-scroll::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:3px; }

@media (max-width:768px) { .cf-dialog--lg { max-width:100%; } .doc-scroll { max-height:64vh; } }
</style>